module.exports = "<md-progress-linear class=progress-linear md-mode=indeterminate ng-show=$ctrl.isLoading()></md-progress-linear>";


//////////////////
// WEBPACK FOOTER
// ./app/common/loader/loader.html
// module id = Zd5J
// module chunks = 1